export const TaxCypressAttribute = {
  buttons: {
    ADD_FINAL_TAX_LIABILITY: 'TaxCypressAttribute:buttons:ADD_FINAL_TAX_LIABILITY',
    EDIT_FINAL_TAX_LIABILITY: 'TaxCypressAttribute:buttons:EDIT_FINAL_TAX_LIABILITY',
    JUMP_TO_CALCULATOR: 'TaxCypressAttribute:buttons:JUMP_TO_CALCULATOR'
  },
  inputs: {},
  views: {
    EMPTY_STATE: 'TaxCypressAttribute:EMPTY_STATE',
    FILLED_STATE: 'TaxCypressAttribute:FILLED_STATE',
    CHANGES_TO_INCLUSION_RATE_TOOLTIP: 'TaxCypressAttribute:CHANGES_TO_INCLUSION_RATE_TOOLTIP'
  },
  finalTaxesCalculator: {
    buttons: {
      CALCULATE: 'TaxCypressAttribute:finalTaxesCalculator:buttons:CALCULATE',
      DOWNLOAD: 'TaxCypressAttribute:finalTaxesCalculator:buttons:DOWNLOAD'
    },
    inputs: {
      SELECT_JURISDICTION: 'TaxCypressAttribute:inputs:SELECT_JURISDICTION',
      SELECT_ASSET_TYPE: 'TaxCypressAttribute:inputs:SELECT_ASSET_TYPE',
      CCA: 'TaxCypressAttribute:inputs:CCA'
    },
    views: {
      CALCULATOR: 'TaxCypressAttribute:finalTaxesCalculator:views:CALCULATOR',
      BREAKDOWN: 'TaxCypressAttribute:finalTaxesCalculator:views:BREAKDOWN'
    }
  },
  probateCalculator: {
    buttons: {
      ESTIMATE: 'TaxCypressAttribute:probateCalculator:ESTIMATE',
      DETAILED_REPORT: 'TaxCypressAttribute:probateCalculator:DETAILED_REPORT'
    },
    inputs: {
      JURISDICTION: 'TaxCypressAttribute:probateCalculator:JURISDICTION',
      LIABILITY_VALUE: 'TaxCypressAttribute:probateCalculator:LIABILITY_VALUE',
      ASSET_VALUE: 'TaxCypressAttribute:probateCalculator:ASSET_VALUE',
      ESTATE_TOTAL_VALUE: 'TaxCypressAttribute:probateCalculator:ESTATE_TOTAL_VALUE',
      ESTATE_TANGIBLE_VALUE: 'TaxCypressAttribute:probateCalculator:ESTATE_TANGIBLE_VALUE',
      ESTATE_INTANGIBLE_VALUE: 'TaxCypressAttribute:probateCalculator:ESTATE_INTANGIBLE_VALUE',
      ESTATE_GROSS_VALUE: 'TaxCypressAttribute:probateCalculator:ESTATE_GROSS_VALUE',
      FIRST_NAME: 'TaxCypressAttribute:probateCalculator:FIRST_NAME',
      LAST_NAME: 'TaxCypressAttribute:probateCalculator:LAST_NAME',
      EMAIL: 'TaxCypressAttribute:probateCalculator:EMAIL',
      PHONE_NUMBER: 'TaxCypressAttribute:probateCalculator:PHONE_NUMBER'
    },
    views: {
      DESCRIPTION: 'TaxCypressAttribute:probateCalculator:views:DESCRIPTION',
      BREAKDOWN: 'TaxCypressAttribute:probateCalculator:views:BREAKDOWN',
      ONTARIO: 'TaxCypressAttribute:probateCalculator:views:ONTARIO',
      CALIFORNIA_TAX: 'TaxCypressAttribute:probateCalculator:views:CALIFORNIA_TAX',
      CALIFORNIA_BOND: 'TaxCypressAttribute:probateCalculator:views:CALIFORNIA_BOND',
      BRITISH_COLUMBIA: 'TaxCypressAttribute:probateCalculator:views:BRITISH_COLUMBIA',
      FINAL_TAXES_CALCULATOR: 'TaxCypressAttribute:views:FINAL_TAXES_CALCULATOR'
    }
  }
};
